
export default {
  name: 'TelegramFixed',

  computed: {
    link() {
      return this.$store.state?.appState?.config?.telegram || '';
    },
  },
};
